// Central step config to avoid duplication across components
import React from "react";
import ProjectMetadata from "../components/home/steps/ProjectMetadata";
import ProjectObjectives from "../components/home/steps/ProjectObjectives";
import QualificationSteps from "../components/home/steps/QualificationSteps";
import ProjectPages from "../components/home/steps/ProjectPages";
import ProjectPageComponents from "../components/home/steps/ProjectPageComponents";
import Qualifications from "../components/home/steps/Qualifications";
import ProjectSettings from "../components/home/steps/ProjectSettings";

export const TOTAL_STEPS = 7;

export const STEP_COMPONENTS = {
  1: <ProjectMetadata />,
  2: <ProjectObjectives />,
  3: <QualificationSteps />,
  4: <ProjectPages />,
  5: <ProjectPageComponents />,
  6: <Qualifications />,
  7: <ProjectSettings />,
};

export function getStepComponent(step) {
  return STEP_COMPONENTS[step] || STEP_COMPONENTS[1];
}
